import React, { useEffect } from "react";
import "./EducationPage.css";

const HealthcarePage = () => {

  useEffect(() => {
    const cards = document.querySelectorAll(".card-wrapper");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            requestAnimationFrame(() => {
              entry.target.classList.add("show");
            });
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      {
        threshold: 0.45,
        rootMargin: "0px 0px -150px 0px",
      }
    );

    cards.forEach((card) => observer.observe(card));

    return () => {
      cards.forEach((card) => observer.unobserve(card));
    };
  }, []);

  const healthcareData = [
    {
      title: "Techno Global Hospital",
      desc: (
        <p>
          "Situated at Barrackpore, Nehru Memorial Techno Global Hospital has become the
          lifeline for the better part of North 24 Parganas. Equipped with modern facilities,
          advanced equipment and state-of-the-art infrastructure, the hospital has touched more
          than two million lives during the course of its prestigious journey. Thanks to an enviable
          list of esteemed doctors and dedicated medical staff, Techno Global Hospital remains a
          torchbearer of cure, compassion and trust in the outskirts of Kolkata. ​"
        </p>
      ),
      img: "/images/ecosystem/Techno-global.jpg",
      link: "https://www.technoglobalhospital.com/"
    },
    {
      title: "Techno Global Multispecialty & Oncology",
      desc: (
        <p>
          "In a bid to make treatment for cancer and other terminal diseases affordable, Techno
          India Group acquired Subodh Mitra Cancer Hospital and today, it has been transformed
          into a 650-bedded, top-notch medical facility – Techno Global Multispeciality &
          Oncology. Located at Sector – III, Salt Lake, the hospital is committed to catering to the
          modern-day health requirements of the city. ​"
        </p>
      ),
      img: "/images/ecosystem/Techno-cancer.jpg",
      link: "https://www.tgmohospital.com/"
    },
    {
      title: "Rotary Techno Netralaya",
      desc: (
        <p>
          "With more than six lakh happy patients, Rotary Techno Netralaya, Salt Lake happens to
          be the go-to eye hospital in the city, for quality treatment at an affordable cost. Apart
          from providing advanced eye care, the foundation has conducted over 50,000 free
          awareness camps in the state and beyond. Rotary Techno Netralaya has made close to
          three lakh successful eye surgeries and offers dental care too, with seasoned experts on
          board. ​"
        </p>
      ),
      img: "/images/ecosystem/Rotary.jpg",
      link: "https://www.rotarytechnonetralaya.com/"
    }
  ];

  return (
    <div>

      {/* Banner */}
      <div className="inner-banner-wrapper">
        <img
          src="/images/page-banner/about.png"
          alt="Banner"
          className="inner-banner-img"
        />
        <div className="inner-banner-overlay">
          <div className="inner-banner-text">Healthcare</div>
        </div>
      </div>

      {/* Content */}
      <div className="overview-container">
        <div className="contain-body">

          {healthcareData.map((item, index) => (
            <div
              className={`card-wrapper ${index % 2 === 1 ? "reverse" : ""}`}
              key={index}
            >

              <div className="card-text">
                <h2>{item.title}</h2>
                {item.desc}

                <a
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  className="learn-more-link"
                >
                  <span className="learn-more-icon">➜</span>
                  <span>Learn more</span>
                </a>
              </div>

              <div className="card-image">
                <img src={item.img} alt={item.title} />
              </div>

            </div>
          ))}

        </div>
      </div>

    </div>
  );
};

export default HealthcarePage;